import { render, staticRenderFns } from "./WasteCollectItemList.vue?vue&type=template&id=0dc9d8b8&scoped=true&"
import script from "./WasteCollectItemList.vue?vue&type=script&lang=js&"
export * from "./WasteCollectItemList.vue?vue&type=script&lang=js&"
import style0 from "./WasteCollectItemList.vue?vue&type=style&index=0&id=0dc9d8b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc9d8b8",
  null
  
)

export default component.exports